import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dc-popover',
  templateUrl: './dc-popover.component.html',
  styleUrls: ['./dc-popover.component.scss'],
})
export class DcPopoverComponent implements OnInit {
  @Input() label: any;
  @Input() body: any;
  @Input() type: 'warning' | 'info';
  @Input() autoClose: number;
@Input() trigger: any
  private timeout: any;

  @ViewChild('p', { read: NgbPopover, static: true })
  private popoverButton: NgbPopover;

  constructor() {}

  ngOnInit(): void {}

  click(): void {
    if (this.popoverButton.isOpen()) {
      clearTimeout(this.timeout);
      this.popoverButton.close();
      return;
    }

    this.popoverButton?.open();
    if (this.autoClose) {
      this.timeout = setTimeout(
        () => this.popoverButton?.close(),
        this.autoClose
      );
    }
  }
}
